<!--
 * @Description: 图表报告聚合页
 * @Author:  单珊珊
 * @Date: 2022-02-23 18:24:17
 * @LastEditTime: 2022-05-18 15:47:29
 * @LastEditors:  
-->
<template>
  <div class="company-filter">
    <div class="container">
      <div class="search">
        <div class="title">报告图表</div>
        <div class="flex-content">
          <div class="type-title">相关领域：</div>
          <div class="type">
            <span v-for="item, index in entity_ntag_filter" :key="index" v-if="item.pid == null" class="search-item" :class="{'active': type == item.id}" @click="changeType(item.id)">{{item.name}}
            </span>
          </div>
        </div>
        <div class="keywords flex-content">
          <div class="type-title">图表搜索:</div>
          <Input v-model="name" search placeholder="搜索“图表名称”、“图表关键词”、“报告名称”" @on-search="changeKey" clearable @on-change="changeKey" />
        </div>
      </div>
      <div class="result-list">
        <Spin fix v-if="loading">
          <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
          <div>Loading</div>
        </Spin>
        <div class="defalut" v-if="!loading && chart_set.records.length < 1">
          <img :src="$store.state.static_img_url+'pic/quesheng-2.png'" alt="" srcset="">
          <p>暂无相关内容</p>
        </div>
        <div class="chart-item" v-for="item, index in chart_set.records" :key="index">
          <div class="image" @click="handReport(item)">
            <img class="img-wrap" v-if="item.reportType == 0" :src="item.filePath | logo_show('/report_type_img')">
            <img class="img-wrap" v-else :src="item.filePath | logo_show('/report_image')">
            <span class="shoucang" v-if="!item.isCollect" @click.stop="addCollect('9', item.id, addCollectCb3, index)"><i class="iconfont">&#xe667;</i></span>
            <span class="shoucang on" v-else @click.stop="cancelCollect('9', item.id, delCollectCb3, index)"><i class="iconfont">&#xe667;</i></span>
            <!-- <span class="flag" :class="{'chart': item.type == 1, 'report': item.type == 2}">{{item.type == 1 ? '相关图表': '相关报告'}}</span> -->
            <img v-if="item.type == 1 && name" class="flag" :src="$store.state.static_img_url + 'pic/vcbeat/chart_flag.png'">
            <img v-if="item.type == 2 && name" class="flag" :src="$store.state.static_img_url + 'pic/vcbeat/report_flag.png'">
          </div>
          <div class="title l2-ellipsis" v-html="item.file_name_keyword"></div>
        </div>
      </div>
      <div class="page">
        <Page :total="chart_set.total" ref="pages" show-elevator @on-change="getNextPage($event)" :page-size="20" />
      </div>
      <ReportModal :isReportModal="is_reportModal" :detail="detail" :relation="relation" @closeModal="closeModal"></ReportModal>
    </div>
  </div>
</template>

<script>
import ReportModal from '@/components/vcbeat/ReportModal'
import { getMeta, getReportChartList } from '@/service.js'
import { collect_mixin } from "js/collect_mixin";
import filter from 'js/filter'
function check() {
    function doCheck(a) {
        (function() {}["constructor"]("debugger")()); 
        doCheck(++a);
    }
    try {
        doCheck(0)
    } catch(err) {}
}
export default {
  mixins: [collect_mixin],
  inject: ["login"],
  data() {
    return {
      debugger_interval: '',
      is_reportModal: false,
      detail: {},
      relation: [],
      type_list: [
        {
          value: '',
          label: '全部'
        },
        {
          value: 1,
          label: '生物医药'
        },
        {
          value: 2,
          label: '医药商业'
        },
        {
          value: 3,
          label: '数字健康'
        },
        {
          value: 4,
          label: '医疗服务'
        },
        {
          value: 5,
          label: '器械与耗材'
        },
      ],
      type: '',
      name: '',
      size: 20,
      page: 1,
      entity_ntag: [
        {
          id: '',
          name: '全部'
        }
      ],
      chart_set: [],
      loading: true
    }
  },
  components: { ReportModal },
  computed: {
    entity_ntag_filter() {
      let arr = this.entity_ntag.filter(item => item.pid == null)
      let index = arr.findIndex(a => a.id == 21)
      if(index > -1) {
        let e = arr[index]
        arr.splice(index, 1)
        arr.splice(1, 0, e)
      }
      return arr
    },
    img_req_url() {
      return this.$store.state.img_req_url
    },
    user_key() {
      return this.$store.state.user_key
    }
  },
  created() {
    if (this.$route.query.keyword) {
      this.name = this.$route.query.keyword
    }
  },
  beforeMount() {
    this.getMeta()
  },
  methods: {
    addCollectCb3(index) {
      this.chart_set.records[index].isCollect = 1
      this.chart_set = [...this.chart_set]
      this.$forceUpdate();
    },
    delCollectCb3(index) {
      this.chart_set.records[index].isCollect = 0
      this.chart_set = [...this.chart_set]
      this.$forceUpdate();
    },
    //获取相关领域
    async getMeta() {
      let res = await getMeta({ name: ['entity_ntag'] }, (error) => {
        this.$Message.error('元数据请求错误！')
      })
      if (res.status == 'success') {
        res.meta.entity_ntag.map(item => {
          this.entity_ntag.push(item)
        })
        this.getReportChartList()
      }
    },
    //获取报告图表
    async getReportChartList() {
      this.loading = true
      let params = {
        name: this.name,
        app_layer_tag: this.type ? [this.type] : [],
        page: this.page,
        size: this.size,
        user_key: this.$store.state.user_key
      }
      let res = await getReportChartList(params, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.code == 0) {
        this.chart_set = res.data
        this.chart_set.records.map(item => {
          // let values = item.fileName.split(this.name);
          // let file_name_keyword =  values.join(`<span style='color: #FA5A00;'>` + this.name + `</span>`)
          let file_name_keyword = this.name ? filter.keyWordHighLight(item.fileName, this.name) : item.fileName
          this.$set(item, 'file_name_keyword', file_name_keyword)
        })
        this.loading = false
      } else {
        this.$Message.error(res.msg)
      }
    },
    //图表弹窗
    async handReport(item) {
      if (!this.user_key) {
        this.login()
        return
      }
      this.detail = item
      let res = await getReportChartList({
        file_id: this.detail.id,
        app_layer_tag: this.detail.reportTag,
        name: '',
        page: 1,
        size: 3
      }, (error) => {
        this.$message.error('请求错误！')
      })
      if (res.code == 0) {
        this.$set(this.$data, 'relation', res.data.records)
        this.is_reportModal = true
      } else {
        this.$message.error(res.msg)
      }
    },
    changeType(val) {
      this.page = 1
      this.type = val
      this.chart_set = []
      this.getReportChartList()
    },
    changeKey() {
      this.page = 1
      this.chart_set = []
      this.getReportChartList()
    },
    closeModal(val) {
      this.is_reportModal = false
    },
    getNextPage(event) {
      if(event > 3 && !this.user_key) {
        this.$refs['pages'].currentPage = this.page
        this.login()
      } else {
        this.page = event
        this.is_reportModal = false
        this.getReportChartList()
      }
    }
  },
  mounted() {
    if (process.env.NODE_ENV != 'development') {
      check()
      this.debugger_interval = setInterval(() => {
        check()
      }, 2000)
    }
  },
  beforeDestroy() {
    clearInterval(this.debugger_interval)
    this.debugger_interval = ''
  },
}
</script>

<style lang="stylus" scoped>
@import '~styles/common_track.stylus'
.ivu-layout-content
  min-height unset !important
.company-filter
  background #fff
  display flex
  justify-content center
.container
  width 1100px
  margin 20px auto 30px
  background #F8F9FA
  padding 0 50px
  .search
    .title
      font-size 16px
      font-family PingFang SC
      font-weight bold
      color #333333
      height 58px
      padding 22px 0 20px 0
      border-bottom 1px solid #E9E9E9
    .flex-content
      display flex
      align-items center
      margin-top 30px
    .type-title
      font-size 14px
      font-family PingFang SC
      font-weight bold
      color #333333
      margin-right 20px
      white-space nowrap
    .type
      .search-item
        font-weight 500
        color #666666
        cursor pointer
        margin-right 33px
      .active
        color #FA5A00
    .keywords
      margin-top 40px
      >>> .ivu-input-wrapper
        width 515px
        .ivu-input
          &:focus
            box-shadow none
            border-color #FA5A00
          &:hover
            border-color #FA5A00
        .ivu-input-search-icon
          &:hover
            color #FA5A00
  .result-list
    margin-top 40px
    display grid
    grid-template-columns repeat(5, 184px)
    grid-template-rows 200px
    grid-auto-columns 184px
    grid-auto-rows 200px
    grid-row-gap 20px
    justify-content space-between
    position relative
    min-height 56vh
    .chart-item
      position relative
      .flag
        position absolute
        right 0
        bottom 0
      .image
        height 136px
        background #FFFFFF
        display flex
        justify-content center
        align-items center
        position relative
        cursor pointer
        img
          max-height 90px
          max-width 146px
          transition all 0.5s
        &:hover
          .img-wrap
            transform scale(1.1)
        .shoucang
          display inline-flex
          justify-content center
          align-items center
          border-radius 3px
          margin-left 10px
          width 21px
          height 21px
          background #F3F3F3
          cursor pointer
          position absolute
          right 10px
          top 10px
          .iconfont
            color #CCCCCC
            font-size 14px
          &.on
            background #FA5A00
            .iconfont
              color #fff
      .title
        margin-top 15px
        font-size 14px
        font-family PingFang SC
        font-weight 500
        color #333333
        line-height 20px
        height 40px
        padding 0 3px
        >>> .high-light
          font-style normal
          color #FA5A00
      .l2-ellipsis
        text-overflow -o-ellipsis-lastline
        overflow hidden
        text-overflow ellipsis
        display -webkit-box
        -webkit-line-clamp 2
        line-clamp 2
        -webkit-box-orient vertical
  .page
    margin-top 18px
    margin-bottom 30px
  >>> .ivu-page
    display flex
    justify-content center
  >>> .ivu-page-item-active
    background #FA7A50
    border none
    a
      color #FFFFFF
  >>> .ivu-page-item
    &:hover
      border-color #FA7A50
      a
        color #FA7A50
  >>>.ivu-spin
    color #FA5A00
  >>>.ivu-page-options-elevator
    input
      &:hover
        color #FA7A50
        border-color #FA7A50
  >>>.ivu-page-next
    &:hover
      border-color #FA7A50
      a
        color #FA7A50
  >>>.ivu-page-prev
    &:hover
      border-color #FA7A50
      a
        color #FA7A50
  >>>.ivu-page-item-jump-next
    &:hover
      i
        &:first-child
          color #FA7A50
  >>>.ivu-page-item-jump-prev
    &:hover
      i
        &:first-child
          color #FA7A50
  >>>.ivu-spin-fix
    .ivu-spin-main
      top 200px
  .defalut
    display flex
    flex-direction column
    align-items center
    width 100%
    position relative
    left 500px
    transform translateX(-92px)
    img
      height 156px
    p
      color #999
      font-size 14px
</style>

